import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

import { French } from "flatpickr/dist/l10n/fr.js";
import { Hindi } from "flatpickr/dist/l10n/hi.js";
import { Urdu } from "../datepicker-lang/ur"; 
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { Arabic } from "flatpickr/dist/l10n/ar.js";
import { Russian } from "flatpickr/dist/l10n/ru.js";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { German } from "flatpickr/dist/l10n/de.js";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { Korean } from "flatpickr/dist/l10n/ko.js";
import { Dutch } from "flatpickr/dist/l10n/nl.js";
import { Chinese } from "../datepicker-lang/zh";
import { Czech } from "flatpickr/dist/l10n/cs.js";
import { Turkish } from "flatpickr/dist/l10n/tr.js";
import { Danish } from "flatpickr/dist/l10n/da.js";
import { Malay } from "../datepicker-lang/ms";
import { Finnish } from "flatpickr/dist/l10n/fi.js";
import { Thai } from "flatpickr/dist/l10n/th.js";
import { Indonesian } from "flatpickr/dist/l10n/id.js";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";
import { Persian } from "flatpickr/dist/l10n/fa.js";
import {Filipino} from "../datepicker-lang/tl"


const mapLanguageToLocale = (langCode) => {
  const baseLang = langCode.split('-')[0];
  
  const localeMap = {
    fr: French,
    hi: Hindi,
    ur: Urdu,
    es: Spanish,
    ar: Arabic,
    ru: Russian,
    pt: Portuguese,
    de: German,
    it: Italian,
    ja: Japanese,
    ko: Korean,
    nl: Dutch,
    zh: Chinese,
    cs: Czech,
    tr: Turkish,
    da: Danish,
    ms: Malay,
    fi: Finnish,
    th: Thai,
    id: Indonesian,
    uk: Ukrainian,
    vi: Vietnamese,
    fa: Persian, 
    tl:Filipino,
    en: null, 
  };

  return localeMap[baseLang] || null;
};

const MortgageDatePicker = ({ 
  onDateChange, 
  value, 
  name = "dueDate", 
  placeholder = "DD/MM/YYYY",
  className = "",
  leftIcon,
  borderColor,
}) => {
  const { i18n } = useTranslation();
  const flatpickrRef = useRef(null);
  
  // Get the current language from i18n
  const currentLocale = mapLanguageToLocale(i18n.language);
  const isRTL = () => {
    const rtlLanguages = ["ar", "fa", "ur"];
    return rtlLanguages.includes(i18n.language);
  };
  return (
    <div className="relative">
        {leftIcon && (
    <div className={`absolute top-[6px]  ${isRTL() ? "right-2 " : "left-3"}`}>
       <p
              className={`${
                borderColor || "border-primary"
              } ${isRTL() ? "border-l pl-[8px]" : "border-r pr-[5px] sm:pr-[8px]"} sm:text-[16px] text-[14px] text-black font-lato-regular-400 `}
            >
              {leftIcon}
            </p>
          </div>
  )}
      <Flatpickr
        ref={flatpickrRef}
        value={value}
        onChange={(selectedDates) => {
          if (selectedDates.length > 0 && onDateChange) {
            onDateChange(selectedDates[0]);
          }
        }}
        options={{       
          locale: currentLocale || "default",
          allowInput: false, 
          clickOpens: true,
          altInput: true,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",
          disableMobile: true,
        }}
        placeholder={placeholder}
        className={`sm:h-[36px] h-[32px] text-sm sm:text-[15px]${isRTL() ? "sm:pr-9 pr-7 pl-1" : "sm:pr-[12px] pl-7 pr-[10px] sm:pl-9"} py-[7.5px] border border-primary border-opacity-50 flex items-center rounded-full focus:outline-none focus:border-primary focus:border-opacity-100 transition-colors ${className}`}
        style={{ 
          minWidth: '120px',
          fontSize: '14px',
          textAlign: 'center',
          fontFamily: 'Lato-Regular, sans-serif',
          backgroundColor: 'white'
        }}
        onKeyDown={(e) => {
            const blockedKeys = [
              "Backspace", "Delete", "ArrowLeft", "ArrowRight",
              "ArrowUp", "ArrowDown", "Enter", " ", "Tab"
            ];
          
            if (blockedKeys.includes(e.key) || e.key.length === 1) {
              e.preventDefault();
            }
          }}
          
        onReady={(selectedDates, dateStr, instance) => {
            
          const input = instance.input;
          if (input) {
            input.setAttribute('readonly', 'true');
            input.style.cursor = 'pointer';
            input.style.backgroundColor = 'white';
          }
        }}
        
      />
    </div>
  );
};

export default MortgageDatePicker;